module.exports = __webpack_public_path__ + "static/media/desktop-icon-24-l-track-laptime.63cb2ee8.svg";